"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_LOADING_START = exports.UI_LOADING_END = void 0;
var UI_LOADING_START = exports.UI_LOADING_START = 'UI_LOADING_START';
var UI_LOADING_END = exports.UI_LOADING_END = 'UI_LOADING_END';